export default __webpack_public_path__ + "static/media/betterbusiness.e535efb1.png";